import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderRadius: 5,
    padding: 10,
  },
  title: {
    textAlign: 'left',
    marginBottom: 2,
  },
  description: {
    textAlign: 'left',
  },
});
